import { FlexBox } from '@thewhite/react-flex-layout';
import { isEqual } from 'lodash';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { ToastContainer, ToastPosition } from 'react-toastify';
import { WsReactBaseComponentInterface, WsReactBaseContainer } from 'ws-react-base-components';
import { ModalStore, ModalStoreView } from 'ws-react-modal-dialog';
import { Footer, TopNavInfinity, WsVoiceInfinitySpinner } from 'ws-voice-infinity-global-module/lib/components';
import { AuthStore, EventStore, GlobalStore } from 'ws-voice-infinity-global-module/lib/store';

interface MainWrapProps {
    children: any;
    globalStore?: GlobalStore;
    authStore?: AuthStore;
    eventStore?: EventStore;
    modalStore?: ModalStore;
    location: any;
}

export interface MainWrapInterface extends WsReactBaseComponentInterface {
    props: MainWrapProps;
    startRedirect: boolean;
    skipRoutes: Array<string | string[]>;
}

@inject('globalStore', 'authStore', 'modalStore', 'eventStore')
@observer
export class MainWrap extends WsReactBaseContainer<MainWrapProps, {}> implements MainWrapInterface {
    startRedirect: boolean = false;
    skipRoutes: Array<string | string[]> = [
        ['/evaluation', '/participant', '/vote'],
    ];

    constructor(props: MainWrapProps) {
        super(props);
        if (this.props.globalStore) {
            this.props.globalStore.handlerPressControl();
        }
    }

    componentDidMount() {
        this.props.globalStore?.setLocation(this.props.location, this.skipRoutes);
    }

    componentWillReceiveProps(newProps: MainWrapProps) {
        if (!isEqual(newProps.location, this.props.location)) {
            this.props.globalStore?.setLocation(newProps.location, this.skipRoutes);
        }
    }

    render(): false | JSX.Element {
        if (!!this.props.globalStore && !!this.props.globalStore.redirect && !this.startRedirect) {
            this.startRedirect = true;
        } else if (!!this.startRedirect && !!this.props.globalStore) {
            this.startRedirect = false;
            this.props.globalStore.clearRedirect();
        }
        return (
            <>
                <WsVoiceInfinitySpinner
                    loading={!!this.props.globalStore ? this.props.globalStore.loading : false}
                    loadingText={!!this.props.globalStore ? this.props.globalStore.loadingText : null}
                    loadingShadowBackground={!!this.props.globalStore ? this.props.globalStore.loadingShadowBackground : false}
                />
                {
                    !!this.props.globalStore && !!this.props.globalStore.redirect && !!this.startRedirect
                        ?
                        <Redirect
                            to={this.props.globalStore.redirect}
                            push={true}
                        />
                        :
                        <FlexBox
                            id="main-wrap"
                            column="start stretch"
                            className="main-wrap"
                            ref="mainWrap"
                        >
                            <FlexBox
                                grow="1"
                                shrink="0"
                                column="start stretch"
                            >
                                <TopNavInfinity
                                    authStore={this.props.authStore}
                                    eventStore={this.props.eventStore}
                                    globalStore={this.props.globalStore}
                                    goToState={this.goToState.bind(this)}
                                    location={this.props.location}
                                />
                                <FlexBox
                                    grow="1"
                                    shrink="0"
                                    column="start stretch"
                                    className="main-body body-2-primary"
                                >
                                    {this.props.children}
                                </FlexBox>
                            </FlexBox>
                            <Footer
                                goToState={this.goToState.bind(this)}
                            />
                            <ModalStoreView
                                modalStore={this.props.modalStore}
                            />
                        </FlexBox>
                }
                <ToastContainer
                    toastClassName="global-toast"
                    position={ToastPosition.BOTTOM_RIGHT}
                />
            </>
        );
    }
}

export default MainWrap;
